// Travel style translations
const TRAVEL_STYLE_TRANSLATIONS: { [key: string]: string } = {
  'backpacker': 'Routard',
  'comfort': 'Confort',
  'mixed': 'Mixte'
};

export function translateTravelStyle(style: string): string {
  return TRAVEL_STYLE_TRANSLATIONS[style] || style;
}